/* eslint-disable @typescript-eslint/no-explicit-any */
import { GET_APP_LIST } from '../constants/APIConstants'
import { getCall, getHostUrl } from '../utility/APIUtility'

export const getAppDetails = (appId: any, callback: any) => {
  const url = getHostUrl() + GET_APP_LIST + '/' + appId
  getCall(url, callback)
}
